/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsCostCalculator204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsCostCalculator505Schema = z.any();

export const optionsCostCalculatorMutationResponseSchema = z.lazy(() => optionsCostCalculator204Schema);
